const FORBIDDEN_TAGS = new Set(['script', 'iframe', 'object', 'embed', 'link', 'meta', 'style'])

export const isEmptyHtmlContent = (html) => {
    const text = String(html || '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    return !text
}

export const sanitizeHtml = (html) => {
    if (!html || typeof html !== 'string') {
        return ''
    }

    if (typeof window === 'undefined' || typeof DOMParser === 'undefined') {
        return html
            .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
            .replace(/on\w+=(["']).*?\1/gi, '')
    }

    const parser = new DOMParser()
    const documentNode = parser.parseFromString(html, 'text/html')

    documentNode.body.querySelectorAll('*').forEach((element) => {
        if (FORBIDDEN_TAGS.has(element.tagName.toLowerCase())) {
            element.remove()
            return
        }

        Array.from(element.attributes).forEach((attribute) => {
            const name = attribute.name.toLowerCase()
            const value = attribute.value || ''
            if (name.startsWith('on') || name === 'srcdoc') {
                element.removeAttribute(attribute.name)
                return
            }
            if ((name === 'href' || name === 'src') && /^\s*javascript:/i.test(value)) {
                element.removeAttribute(attribute.name)
            }
        })

        if (element.tagName.toLowerCase() === 'a') {
            element.setAttribute('target', '_blank')
            element.setAttribute('rel', 'noopener noreferrer')
        }
    })

    return documentNode.body.innerHTML
}

export default sanitizeHtml
